import React from "react";
import Logo from "../../../../../components/common/layout/header/Logo";
import { useRestaurantContext } from "../../../RestaurantPage";
import { Button, Stack } from "@mui/material";

interface IHeader {
  height: string;
}

function Header({ height }: IHeader) {
  const { showMenu, setShowMenu } = useRestaurantContext();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={1}
      sx={{
        height: height,
        backgroundColor: "background.paper",
        pl: 2,
      }}
    >
      <Logo />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        gap={1}
        sx={{ flex: 1, height: "100%" }}
      >
        <Stack direction="row" alignItems="flex-end" sx={{ height: "100%" }}>
          <Button
            onClick={() => setShowMenu(false)}
            variant="contained"
            sx={{
              textTransform: "none",
              boxShadow: "none",
              width: "160px",
              height: "42px",
              borderRadius: "10px 0px 0px 0px",
              backgroundColor: showMenu ? "background.default" : "",
              color: showMenu ? "" : "common.white",
              "&:hover": { boxShadow: "none" },
            }}
          >
            Phiếu ăn
          </Button>
          <Button
            onClick={() => setShowMenu(true)}
            variant="contained"
            sx={{
              textTransform: "none",
              boxShadow: "none",
              width: "160px",
              height: "42px",
              borderRadius: "0px 10px 0px 0px",
              backgroundColor: showMenu ? "" : "background.default",
              color: showMenu ? "common.white" : "",
              "&:hover": { boxShadow: "none" },
            }}
          >
            Thực đơn
          </Button>
        </Stack>
      </Stack>
      <div></div>
    </Stack>
  );
}

export default Header;
